import "./App.css";
import { register } from "swiper/element/bundle";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import ReactDOM from "react-dom/client";
import { store } from "./redux/store/store";
import HomeScreen from "./dashboard/dashscreen/HomeScreen";
import DashBoardScreen from "./AdminDashboard/dashscreen/DashBoardScreen";
import SideBarScreen from "./AdminDashboard/dashscreen/sidebar/SideBarScreen";
import AdminLogin from "./AdminDashboard/dashscreen/eraser/AdminLogin";
import AdminDashboard from "./AdminDashboard/dashscreen/eraser/AdminDashboard";
import HomeDirectoryManager from "./AdminDashboard/dashscreen/eraser/HomeDirectoryManager";

import ClientLogin from "./AdminDashboard/dashscreen/eraser/ClientLogin";
import RegisterClient from "./AdminDashboard/dashscreen/eraser/ClientRegister";
import ClientSideBarScreen from "./AdminDashboard/dashscreen/sidebar/ClientSideBarScreen";
import ClientDashboard from "./AdminDashboard/dashscreen/eraser/ClientDashboard";
import AITool from "./AdminDashboard/dashscreen/eraser/AITool";
import BlogList from "./AdminDashboard/dashscreen/eraser/BlogList";
import BlogCreate from "./AdminDashboard/dashscreen/eraser/BlogCreate";
import BlogEdit from "./AdminDashboard/dashscreen/eraser/BlogEdit";
import BlogScreen from "./dashboard/dashscreen/BlogScreen";
import BlogDetail from "./dashboard/dashscreen/BlogDetail";
import UserProfile from "./AdminDashboard/dashscreen/sidebar/UserProfile";
import AIFeaturesScreen from "./dashboard/dashscreen/AIFeaturesScreen";


// Private Route Wrappers for different user types
const PrivateAdminRoutes = () => {
  const location = useLocation();
  const { userData } = useSelector((store) => store.userReducer);
  const isAuthenticated = !!userData;

  return isAuthenticated ? <Outlet /> : <Navigate to="/admin-login" state={{ from: location }} replace />;
};

const PrivateClientRoutes = () => {
  const location = useLocation();
  const { userData } = useSelector((store) => store.userReducer);
  const isAuthenticated = !!userData;

  return isAuthenticated ? <Outlet /> : <Navigate to="/client-login" state={{ from: location }} replace />;
};

export default function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/blogs" element={<BlogScreen />} />
          <Route path="/blog-detail/:id" element={<BlogDetail />} />
          <Route path="/ai-features" element={<AIFeaturesScreen />} />



          <Route path="/admin-login" element={<AdminLogin />} />
        
          <Route path="/login" element={<ClientLogin />} />
          <Route path="/signup" element={<RegisterClient />} />


          {/* Private Routes */}
          <Route path="/admin" element={<PrivateAdminRoutes />}>
            <Route element={<SideBarScreen />}>
              <Route index element={<DashBoardScreen />} />
              <Route path="admin-dashboard" element={<AdminDashboard />} />
              <Route path="home-directory-manager" element={<HomeDirectoryManager />} />
              <Route path="ai-tool" element={<AITool />} />
              <Route path="blogs" element={<BlogList />} />
              <Route path="blogs/create" element={<BlogCreate />} />
              <Route path="blogs/edit/:id" element={<BlogEdit />} />
              
            </Route>
          </Route>


          <Route path="/user" element={<PrivateClientRoutes />}>
            <Route element={<ClientSideBarScreen />}>
              <Route index element={<ClientDashboard />} />
              <Route path="user-dashboard" element={<ClientDashboard />} />
              <Route path="profile" element={<UserProfile />} />

            </Route>
          </Route>


        </Routes>
      </BrowserRouter>
    </Provider>
  );
}
